import { BaseOrganization } from '../types/organization.types';

export const moveCurrentOrganizationToFirst = (
  organizations: BaseOrganization[],
  currentOrgId: string,
) =>
  organizations
    .filter((organization) => organization._id === currentOrgId)
    .concat(
      organizations.filter((organization) => organization._id !== currentOrgId),
    );

export const getSwitchableOrganizations = (
  organizations: BaseOrganization[],
  currentOrgId: string,
) =>
  moveCurrentOrganizationToFirst(
    organizations.filter((organization) => organization.status),
    currentOrgId,
  );

export const getOrganizationById = (
  organizations: BaseOrganization[],
  organizationId: string | null,
) => {
  const found =
    organizations.find((organization) => organization._id === organizationId) ||
    organizations[0];

  return found
    ? {
        label: found.name,
        value: found._id,
      }
    : null;
};
